import {isMobile} from "is-mobile";

export const IS_MOBILE: boolean = isMobile();

